// StatBits.js — small pieces the club and season pages share: a stat tile
// (big gradient number over a label) and match rows (date | match | badge,
// the Records page's list style).

import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { BRAND } from "../theme";

export function Tile({ value, label }) {
  return (
    <Box sx={{ px: 1.75, py: 1.5, borderRadius: 2, background: "rgba(255,255,255,0.035)", border: "1px solid rgba(255,255,255,0.08)" }}>
      <Typography
        sx={{
          fontSize: { xs: 22, sm: 26 },
          fontWeight: 900,
          lineHeight: 1.1,
          letterSpacing: "-0.02em",
          fontFeatureSettings: '"tnum"',
          background: BRAND.gradient,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {value}
      </Typography>
      <Typography sx={{ color: BRAND.textSecondary, fontSize: 11, fontWeight: 800, letterSpacing: "0.14em", textTransform: "uppercase", mt: 0.6 }}>
        {label}
      </Typography>
    </Box>
  );
}

// rows: [{ date, text, badge?, to?, badgeTo? }]; `to` links the text and
// `badgeTo` the badge (e.g. a meeting's season).
export function MatchRows({ rows }) {
  return (
    <Box
      sx={{
        mb: 2,
        "& .r-row": {
          display: "grid",
          gridTemplateColumns: { xs: "1fr auto", sm: "150px 1fr auto" },
          alignItems: "center",
          columnGap: 2,
          py: 1.1,
          borderBottom: "1px solid rgba(255,255,255,0.06)",
        },
        "& .r-date": { color: BRAND.textSecondary, fontSize: 13, fontFeatureSettings: '"tnum"', gridColumn: { xs: "1 / 2", sm: "auto" } },
        "& .r-text": { color: "#fff", fontSize: 15, fontWeight: 700, textDecoration: "none", gridColumn: { xs: "1 / 2", sm: "auto" }, gridRow: { xs: 2, sm: "auto" } },
        "& a.r-text:hover": { color: BRAND.cyan },
        "& .r-badge": {
          gridRow: { xs: "1 / 3", sm: "auto" },
          gridColumn: { xs: 2, sm: "auto" },
          justifySelf: "end",
          color: "#fff",
          fontSize: 11.5,
          fontWeight: 800,
          letterSpacing: "0.04em",
          px: 1.25,
          py: 0.4,
          borderRadius: 999,
          background: "rgba(111,93,245,0.25)",
          border: "1px solid rgba(111,93,245,0.45)",
          whiteSpace: "nowrap",
          textDecoration: "none",
        },
        "& a.r-badge:hover": { borderColor: BRAND.cyan },
      }}
    >
      {rows.map((r, i) => (
        <div className="r-row" key={i}>
          <span className="r-date">{r.date}</span>
          {r.to ? (
            <RouterLink className="r-text" to={r.to}>
              {r.text}
            </RouterLink>
          ) : (
            <span className="r-text">{r.text}</span>
          )}
          {r.badge &&
            (r.badgeTo ? (
              <RouterLink className="r-badge" to={r.badgeTo}>
                {r.badge}
              </RouterLink>
            ) : (
              <span className="r-badge">{r.badge}</span>
            ))}
        </div>
      ))}
    </Box>
  );
}
